import { memo } from 'react';

import { TabContent } from '../TabContent';

import { MeetingTranscriptView } from './MeetingTranscriptView';

import type { MeetingId } from '../meetings.types';

interface MeetingTranscriptProps {
  meetingId: MeetingId;
  isInPopup?: boolean;
}

export const MeetingTranscript = memo(
  ({ meetingId, isInPopup = false }: MeetingTranscriptProps) => {
    if (isInPopup)
      return <MeetingTranscriptView meetingId={meetingId} isInPopup />;

    return (
      <TabContent className="px-0 h-[calc(var(--main-outlet-height)-12rem)]">
        <MeetingTranscriptView meetingId={meetingId} />
      </TabContent>
    );
  },
  (p, n) => p.meetingId === n.meetingId && p.isInPopup === n.isInPopup
);
